import { render } from "./Japan.vue?vue&type=template&id=91f23b34"
import script from "./Japan.vue?vue&type=script&lang=js"
export * from "./Japan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__